import React from 'react';
import './Badge.css';

export type BadgeStatus = 'draft' | 'sent' | 'paid' | 'overdue' | 'void' | 'default';

export interface BadgeProps {
  /** Badge status determines the color scheme */
  status?: BadgeStatus;
  /** Badge size */
  size?: 'sm' | 'md' | 'lg';
  /** Badge content */
  children: React.ReactNode;
  /** Additional CSS classes */
  className?: string;
}

export const Badge: React.FC<BadgeProps> = ({
  status = 'default',
  size = 'md',
  children,
  className = '',
}) => {
  const classNames = [
    'ui-badge',
    `ui-badge--${status}`,
    `ui-badge--${size}`,
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return <span className={classNames}>{children}</span>;
};

Badge.displayName = 'Badge';
